
import {
  Component,
  DestroyRef,
  inject,
  Input,
  ElementRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AccountingService } from 'src/app/accounting/services/accounting.service';
import { formatPhoneNumber } from 'src/app/shared/functions';
import { ContactTypes, ModalID, ModalType } from 'src/app/shared/models/constants';
import { ReservedInputs } from 'src/app/shared/models/general';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-reserve-inputs',
    templateUrl: './reserve-inputs.component.html',
    styleUrl: './reserve-inputs.component.scss',
    standalone: true,
    imports: [NgSelectModule, FormsModule]
})
export class ReserveInputsComponent {
  @Input() context: any;
  private destroyRef = inject(DestroyRef);
  subscriptions = new Subscription();
  reserve_inputs: ReservedInputs = new ReservedInputs();
  modal_id: number = ModalID.reserve_inputs;
  customer_placeholder: string = 'Select Customer';
  public formatPhoneNumber = formatPhoneNumber;

  modalRef: BsModalRef;
  modalConfig = {
    animated: true,
  };

  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    public sharedService: SharedService,
    public accountingService: AccountingService,
  ) {
       // customer_contact_to_add$
        this.subscriptions.add(
          this.accountingService.customer_contact_to_add$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((response) => {
              this.accountingService.addNewCustomer(response);
              this.sharedService.raiseSuccessToast('Customer added successfully');          
            })
        );
  }

  ngOnInit(): void { }

  // Closes the Modal
  closeModal() {
    this.sharedService.reserve_firearm_inputs_canceled$.next(this.reserve_inputs);
    this.modalService.hide(this.modal_id);
  }
  addNewCustomer() {
    this.sharedService.openAddEditContactModal(ModalType.add, ContactTypes.customer);
  }
  editCustomer() {
    const customer = this.accountingService.customers.find(
      (customer) => customer.id === this.reserve_inputs.reserved_for
    );
    this.sharedService.openAddEditContactModal(
      ModalType.edit,
      ContactTypes.customer,
      customer
    );
  }
  submit() {
    this.sharedService.reserve_firearm_inputs_captured$.next(this.reserve_inputs);
    this.modalService.hide(this.modal_id);
  }
  customerSelected() {
    console.warn(this.reserve_inputs.reserved_for);
    if (this.reserve_inputs.reserved_for) {
      this.customer_placeholder = null;
    } else {
      this.customer_placeholder = 'Select Customer'; 
    }
  }

  ngOnDestroy() {
//    this.sub.unsubscribe();
  }
}
// looks like when I remove a firearm from the reserve list it doesn't remove it from the firearm list in the db
// but it changes the state to available